import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { IAvailableTypes, IConstantItem } from 'src/app/core/models/available-types.interface';
import { ICountry } from 'src/app/core/models/country.interface';
import { PageParams } from 'src/app/core/models/page-params.model';
import { ConstantService } from 'src/app/core/services/constant.service';
import { MarketplacesService } from 'src/app/core/services/marketplaces.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { UploadFileService } from 'src/app/core/services/upload-file.service';
import { UserService } from 'src/app/core/services/user.service';
import {
    ConsolidateShipmentsDetailsComponent
} from 'src/app/modules/consolidate-shipments/components/consolidate-shipments-details/consolidate-shipments-details.component';
import { OrderType } from 'src/app/shared/enums/order-type.enum';
import { SaleOrderStatus } from 'src/app/shared/enums/sale-order-status.enum';
import { SaleOrderType } from 'src/app/shared/enums/sale-order-type.enum';
import { ConfirmPopupDialog } from 'src/app/shared/popups/confirm-popup/confirm-popup.component';
import {
    HideShowFieldsComponent
} from 'src/app/shared/popups/hideshow-fields/hideshowfields.component';
import {
    OriginCountryPopupDialog
} from 'src/app/shared/popups/origin-country/origin-country-popup.component';

import { DatePipe } from '@angular/common';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';

import { PlaceStatus } from '../../../../shared/enums/place-status.enum';
import { RegistrationService } from '../../../customer-registration/services/registration.service';
import { LocalStorageService } from '../../../empact-shop/core/services/local-storage.service';
import {
    SaleOrderDetailsComponent
} from '../../components/sale-order-details/sale-order-details.component';
import {
    XlsxUploadPopupPopupComponent
} from '../../invat-order-search-page/xlsx-upload-popup/xlsx-upload-popup.component';
import { IOrderListItem } from '../../models/order-list-item';
import { ISaleOrder } from '../../models/sale-order.interface';
import { SaleOrderService } from '../../services/sale-order.service';
import { FieldList } from './hideshow-fields-param';
import { ShipmentSubType } from 'src/app/shared/enums/shipment-subtype.enum';
import { ConsolidateShipmentService } from 'src/app/core/services/consolidate-shipments.service';
import { deliveredStatuses } from 'src/app/core/constants.enum';

const Field_List: FieldList[] = [
    {
        key: 'reorder',
        value: false,
        label: 'Reorder'
    },
    {
        key: 'eciOrderDate',
        value: false,
        label: 'Empact Order Date'
    },
    {
        key: 'orderId',
        value: false,
        label: 'Order Id'
    },
    {
        key: 'stripeAmount',
        value: false,
        label: 'Stripe Amount'
    },
    {
        key: 'stripeRefundAmount',
        value: false,
        label: 'Stripe Refund Amount'
    },
    {
        key: 'marketplaceVat',
        value: false,
        label: 'Market place VAT'
    },
    {
        key: 'conversionRate',
        value: false,
        label: 'Conversion Rate'
    },
    {
        key: 'empactVatAmountEur',
        value: false,
        label: 'Empact VAT Amount (EUR)'
    },
    {
        key: 'empactTotalOrderAmountEur',
        value: false,
        label: 'Emapct Total Order Amount (EUR)'
    },
    {
        key: 'eciVat',
        value: false,
        label: 'Amount Exc.VAT'
    },
];

@Component({
    selector: 'marketplace-sales-order-page',
    templateUrl: './marketplace-sales-order-page.component.html',
    styleUrls: ['./marketplace-sales-order-page.component.scss']
})
export class MarketplaceSalesOrderPageComponent implements OnInit {
    @ViewChild('fileInput') fileInput: any;

    sub$: Subscription = new Subscription();
    pageParams: PageParams = new PageParams();
    fromData: FormControl = new FormControl('');
    toData: FormControl = new FormControl('');
    orderStatus: FormControl = new FormControl(null);
    //customerType: FormControl = new FormControl(null);// Deprecate Company type
    searchStr = new FormControl('');
    searchCountry = new FormControl('');
    searchorMarketplaces: FormControl = new FormControl('');
    searchorderStatus: FormControl = new FormControl('');
    //searchcustomerType: FormControl = new FormControl('');// Deprecate Company type
    searchCustomerName: FormControl = new FormControl('');
    customerName: FormControl = new FormControl('');
    amountType: FormControl = new FormControl('');
    customerCountry: FormControl = new FormControl('');
    shopIdByfilter: FormControl = new FormControl('');
    searchShopIdDropDown = new FormControl('');
    currentSort: Sort;
    sumOfTotalFIelds: any = [];
    sumOfTotalFIeldsIncludingCancelled: any = [];
    previousUrl: string = null;
    currentUrl: string = null;
    saleOrdersList: ISaleOrder[];
    availableTypes: IAvailableTypes;
    showLoader: boolean = false;

    listOfSelectedItems: number[] = [];
    listOfSelectedItemsBody: ISaleOrder[] = [];

    previousePageCustomer: number = 0;
    totalPagesCustomers: number = 0;

    companyList: any[];
    previus_search: any;
    routeSubscription: Subscription;
    amountTypes: Array<object>;
    previousPageCountry = 0;
    availableCountries: ICountry[];
    totalPageCountries: number = 1;
    getAllShops: any = [];
    previousPageShops: number = 0;
    totalPagesShops: number = 1;
    isLoadingShops: boolean = false;
    private shopRequestId = 0;
    packageId: number;

    fieldList = Field_List;
    addNewSaleOrder: boolean = false;

    fullCountriesList: ICountry[];
    marketplaceTypes: IConstantItem[];
    @ViewChild('allSelected') private allSelected: MatOption;
    @ViewChild('allEUSelected') private allEUSelected: MatOption;

    get isAdmin(): boolean {
        return this.userSvc.isAdmin;
    }

    pageChanged(e: PageParams): void {
        this.pageParams.pageIndex = e.pageIndex;
        this.pageParams.pageSize = e.pageSize;
        this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin ? this.getList(e.pageIndex + 1, e.pageSize, this.searchStr.value) : this.getList(e.pageIndex + 1, e.pageSize, this.searchStr.value, this.userSvc.company.id);
    }

    constructor(
        private router: Router,
        public localStorageSvc: LocalStorageService,
        public userSvc: UserService,
        private dialog: MatDialog,
        private saleOrderSvc: SaleOrderService,
        private datePipe: DatePipe,
        private constSvc: ConstantService,
        private notify: NotificationService,
        private marketplaceSvc: MarketplacesService,
        private regSvc: RegistrationService,
        public uploadFileSvc: UploadFileService,
        private consolidateShipmentService: ConsolidateShipmentService
    ) {
        this.amountTypes = [
            { 'id': '0', 'name': 'All' },
            { 'id': '1', 'name': 'up to 150' },
            { 'id': '2', 'name': 'over to 150' },
        ]
    }

    displayedColumns: string[] = [
        'checkboxes',
        'donwloadDocuments',
        'reorder',
        //'hasErrors',
        'returns',
        'eciOrderDate',
        'orderDate',
        'customerName',
        //'customerType',// Deprecate Company type
        'shopId',
        'shopName',
        'consolNumber',
        'impShipment',
        'orderID',
        'morderID',
        'shipmentId',
        'originCountryName',
        'countryName',
        'carrier',
        'trackingNumber',
        'orderCurrency',
        'stripeAmount',
        'stripeRefundAmount',
        'conversionRate',
        'eciVat',
        'totalWithoutVat',
        'vatCharges',
        'empactVatAmountEur',
        'empactTotalOrderAmountEur',
        'orderAmount',
        'marketPlace',
        'deliveryDate',
        'orderStatus',

        // ADED FOR QA TEAM - NOT VISIBLE IN UI FOR USERS
        'eciSellOrderTotalTest',
        'shippingPriceTest',
        'productsTest'
    ];
    dataSource;

    // Deprecate Company type
    // get customerTypes(): IConstantItem[] {
    //     if (!this.availableTypes) {
    //         return;
    //     }
    //     return this.availableTypes.CompanyType;
    // }

    get orderStatuses(): IConstantItem[] {
        if (!this.availableTypes) {
            return;
        }
        return this.availableTypes.SaleOrderStatus;
    }

    @HostListener('window:beforeunload', ['$event'])
    unloadNotification($event: any) {
        const req = {
            name: 'B2B_SALES_ORDER_VISIBLITY_FIELD_RULE',
            label: 'B2B_SALES_ORDER_VISIBLITY_FIELD_RULE Listview Fields setting',
            value: JSON.stringify(Field_List)
        };
        this.constSvc.saveSettings(req).subscribe(data => {
            this.routeSubscription && this.routeSubscription.unsubscribe();
            if (!data) {
                return;
            }
        });
    }

    ngOnInit(): void {
        this.marketplaceTypes = this.marketplaceSvc?.availableMarketplaces$?.getValue();
        this.getListOfCountries();
        this.getAllShopsData();
        if (this.userSvc.isOfflineCustomer || this.isAdmin) {
            this.displayedColumns.push(
                'buyerName',
                'paymentTerms'
            );
        }

        this.searchCountry.valueChanges.subscribe(value => {
            this.previousPageCountry = 0;
            this.getListOfCountries();
        });

        this.searchShopIdDropDown.valueChanges
            .pipe(debounceTime(500))
            .subscribe((value) => {
                this.previousPageShops = 0;
                this.getAllShopsData(1, 20, value || '');
            });
        this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin ? this.getList(1, 100, '') : this.getList(1, 100, '', this.userSvc.company.id);
        this.constSvc.availableTypes.subscribe(data => {
            this.availableTypes = data;
        });

        this.searchStr.valueChanges.pipe(debounceTime(500)).subscribe(value => {
            this.search();
        });
        this.getListCompanies();

        this.searchCustomerName.valueChanges.pipe(debounceTime(500)).subscribe(value => {
            this.previousePageCustomer = 0;
            this.getListCompanies();
        });

        this.constSvc.getAvailableCountries().subscribe(data => {
            this.fullCountriesList = data;
        });
    }

    getPackageType(
        companyId: number = this.userSvc.company.id
    ): void {
        this.userSvc.getPackageTypeByCompanyId(companyId).subscribe(response => {
            this.packageId = response.packageId;
        })
    }

    getListOfCountries(
        page: number = this.previousPageCountry + 1,
        q: string = this.searchCountry.value || '',
        limit: number = 1000,
    ): void {
        this.constSvc.getAvailableCountriesForScroll(page, limit, true, q).subscribe(data => {
            if (!data) { return; }
            if (data.meta.currentPage > 1) { this.availableCountries = [...this.availableCountries, ...data.items]; }
            else { this.availableCountries = data.items; }
            this.previousPageCountry = data.meta.currentPage;
            this.totalPageCountries = data.meta.totalPages;
        });
    }

    clearFilters(): void {
        this.searchStr = new FormControl('');
        this.fromData = new FormControl('');
        this.toData = new FormControl('');
        //  this.marketplaces = new FormControl(null);
        this.orderStatus = new FormControl(null);
        this.customerName = new FormControl('');
        this.amountType = new FormControl('');
        this.customerCountry = new FormControl('');
        this.shopIdByfilter = new FormControl('');
    }

    isDataNotCorrect(item: FormControl): boolean {
        return item.value === null;
    }

    async getList(
        page: number = this.pageParams?.pageIndex + 1,
        limit: number = this.pageParams?.pageSize,
        q: string = this.searchStr.value,
        companyId: number = this.customerName.value,
        isSelectAll: boolean = false,
        amountType: string = this.amountType.value,
        customerCountry: string = this.customerCountry.value,
        shopId: string = this.shopIdByfilter.value,
        orderField: string = this.currentSort?.active || '',
        orderDir: string = this.currentSort?.direction.toUpperCase() || '',
    ): Promise<void> {
        console.log('isSelectAll getList');
        console.log(isSelectAll);
        this.showLoader = true;
        await this.saleOrderSvc.getMarketplaceOrders(
            page,
            limit,
            q,
            companyId,
            isSelectAll,
            amountType,
            customerCountry,
            shopId,
            this.prepareSearchParams,
            orderField,
            orderDir,
            false,
            SaleOrderType.IsB2B.toString()
        ).subscribe({
            next: (data) => {
                this.showLoader = false;
                if (!data) {
                    return;
                }
                if(isSelectAll){
                    this.showLoader = false;
                    this.listOfSelectedItems = data.items.map(item => item.id);
                    this.listOfSelectedItemsBody = [];
                }else{
                    const duplicates = this.findDuplicate(data.items);
                    for (const item of data.items) {

                        if (duplicates.length > 0) {
                            const marketplaceOrderId = (item?.marketplace?.marketplaceOrderId?.length > 6 ?
                                item?.marketplace?.marketplaceOrderId?.slice(-5) : item?.marketplace?.marketplaceOrderId);

                            if (duplicates.indexOf(marketplaceOrderId) > -1) {
                                item['color'] = '#eba5a5';
                            }
                        }

                    }

                    this.dataSource = data.items;
                    this.saleOrdersList = data.items;
                    this.pageParams.pageSize = data.meta.itemsPerPage;
                    this.pageParams.pageIndex = data.meta.currentPage - 1;
                    this.pageParams.length = data.meta.totalItems;
                    this.sumOfTotalFIelds = data.totals[0];
                }
            },
            error: (err) => {
                console.error('sale Order error:', err);
                this.showLoader = false;
            }
        });

        // TO DO - NEED TO CHECK WHY NEED 2 CALLS (LOOK TO includingCancelled PARAM)
        // this.saleOrderSvc.getOrdersTotalB2B(page, limit, q, companyId, amountType, customerCountry, this.prepareSearchParams,
        //     orderField, orderDir, false, false, true, false,
        //     PlaceStatus.Confirmed, {}, true)
        //     .subscribe((data) => {
        //         this.sumOfTotalFIelds = data[0];
        //     });
        this.saleOrderSvc.getOrdersTotalB2B(page, limit, q, companyId, amountType, customerCountry, this.prepareSearchParams,
            orderField, orderDir, true, false, true, false,
            PlaceStatus.Confirmed, {}, true)
            .subscribe((data) => {
                this.sumOfTotalFIeldsIncludingCancelled = data[0];
            });
    }

    toggleAllSelection() {
        if (this.allSelected.selected) {
            this.customerCountry
                .patchValue([...this.availableCountries.map(item => item.name), 0]);
        } else {
            this.customerCountry.patchValue([]);
        }
    }

    toggleAllEUSelection() {
        if (this.allEUSelected.selected) {
            this.customerCountry
                .patchValue([...this.availableCountries.map(item => item.name !== 'United Kingdom' ? item.name : ''), 1]);
        } else {
            this.customerCountry.patchValue([]);
        }
    }

    getAllShopsData(
        page: number = this.previousPageShops + 1,
        limit: number = 20,
        q: string = this.searchShopIdDropDown.value
    ): void {
        if (page > 1 && (this.isLoadingShops || this.previousPageShops >= this.totalPagesShops)) {
            return;
        }
        const requestId = ++this.shopRequestId;
        this.isLoadingShops = true;
        this.saleOrderSvc.getAllShops(q || '', page, limit).subscribe(
            (result) => {
                if (requestId !== this.shopRequestId) {
                    return;
                }
                const items = Array.isArray(result) ? result : result?.items || [];
                const meta = result?.meta;
                if (meta?.currentPage > 1) {
                    const existingIds = new Set(this.getAllShops.map((shop) => shop.shopId));
                    this.getAllShops = [
                        ...this.getAllShops,
                        ...items.filter((shop) => !existingIds.has(shop.shopId)),
                    ];
                } else {
                    this.getAllShops = this.keepSelectedShops(items);
                }
                this.previousPageShops = meta?.currentPage || page;
                this.totalPagesShops = meta?.totalPages || 1;
                this.isLoadingShops = false;
            },
            () => {
                if (requestId === this.shopRequestId) {
                    this.isLoadingShops = false;
                }
            }
        );
    }

    onShopDropdownOpened(): void {
        this.previousPageShops = 0;
        this.getAllShopsData(1, 20, this.searchShopIdDropDown.value || '');
    }

    private keepSelectedShops(shops: any[] = []): any[] {
        const selectedValues = this.shopIdByfilter?.value;
        if (!selectedValues || (Array.isArray(selectedValues) && selectedValues.length === 0)) {
            return shops;
        }
        const values = Array.isArray(selectedValues) ? selectedValues : [selectedValues];
        const selected = this.getAllShops.filter(
            (shop) =>
                values.some((value) => value == shop.shopId) &&
                !shops.some((item) => item.shopId == shop.shopId)
        );
        return selected.length ? [...shops, ...selected] : shops;
    }

    trackByShopId(index: number, shop: any): number | string {
        return shop?.id ?? shop?.shopId ?? index;
    }

    trackByCompanyId(index: number, company: any): number | string {
        return company?.id ?? index;
    }

    private async updateInfo(id): Promise<ISaleOrder> {
        return this.saleOrderSvc.getOrderById(id)
            .toPromise()
            .then((data) => {
                return data;
            });
    }

    public async openDialog(order?) {
        const orderInfo = order?.id ? await this.updateInfo(order.id) : null;

        const dialogRef = this.dialog.open(SaleOrderDetailsComponent, {
            maxHeight: '600px',
            width: '900px'
        });
        dialogRef.componentInstance.createMode = true;
        dialogRef.componentInstance.isB2BSaleOrder = true;
        dialogRef.componentInstance.isMarketplaceSO = true;
        dialogRef.componentInstance.header = 'Sales Management - Add Sales Order';
        dialogRef.componentInstance.marginTop = '0';
        if (order?.id) {
            dialogRef.componentInstance.info = orderInfo;
        }
        dialogRef.afterClosed()
            .subscribe((result) => {
                this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin ?
                    this.getList(1, 100, '') :
                    this.getList(1, 100, '', this.userSvc.company.id);

                this.reloadAmountOfNewSO();
            });
    }

    get prepareSearchParams(): any {
        const empactType = this.marketplaceTypes?.find((type) => type.name === 'Empact');
        return {
            marketplaces: !!empactType ? [empactType?.id] : [],
           // companyTypes: this.customerType.value ? this.customerType.value : '',// Deprecate Company type
            dateTo: this.toData.value && this.toData.value !== null ? this.datePipe.transform(this.toData.value, 'yyyy-MM-dd') : '',
            dateFrom: this.toData.value && this.fromData.value !== null ? this.datePipe.transform(this.fromData.value, 'yyyy-MM-dd') : '',
            orderStatus: this.orderStatus.value ? this.orderStatus.value : '',
        };
    }

    sortData(sort: Sort): void {
        const data = this.saleOrdersList.slice();
        if (!sort.active || sort.direction === '') {
            this.saleOrdersList = data;
            this.dataSource = new MatTableDataSource<IOrderListItem>(this.saleOrdersList);
            return;
        }

        this.currentSort = sort;
        this.getList(this.pageParams?.pageIndex + 1, this.pageParams?.pageSize,
            this.searchStr.value || '', this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin ? '' : this.userSvc.company.id);
    }

    search(): void {
        this.clearSelection();
        this.getList(1, 100, this.searchStr.value, this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin ? this.customerName.value : this.userSvc.company.id);
    }

    deleteOrders(): void {
        if (!this.listOfSelectedItems) {
            return;
        }
        const dialogRef = this.dialog.open(ConfirmPopupDialog);
        dialogRef.componentInstance.message = 'Please confirm deleting';
        dialogRef.componentInstance.rightBtnText = 'Delete';
        dialogRef.afterClosed().subscribe(value => {
            if (!value) {
                return;
            }

            this.saleOrderSvc.deleteOrders(this.listOfSelectedItems).subscribe(() => {
                this.getList();
                this.listOfSelectedItems = [];
                this.notify.showSuccessMessage('Deleted successfully');
            }, err => {
                this.notify.showSuccessMessage('Something went wrong');
                console.log('Error => ', err);
            });
        });
    }

    regenerateOrdersInvoice(): void {
        if (!this.listOfSelectedItems) {
            return;
        }
        const dialogRef = this.dialog.open(ConfirmPopupDialog);
        dialogRef.componentInstance.message = 'Please confirm regeneration of invoice';
        dialogRef.componentInstance.rightBtnText = 'Regenerate Invoice';
        dialogRef.afterClosed().subscribe(value => {
            if (!value) {
                return;
            }

            this.saleOrderSvc.regenrateOrdersInvoice(this.listOfSelectedItems).subscribe(() => {
                this.getList();
                this.listOfSelectedItems = [];
                this.notify.showSuccessMessage('Invoice Regenerated successfully');
            }, err => {
                this.notify.showSuccessMessage('Something went wrong');
                console.log('Error => ', err);
            });
        });
    }

    deleteDuplicateds(): void {
        if (!this.customerName?.value) {
            return;
        }
        const dialogRef = this.dialog.open(ConfirmPopupDialog);
        dialogRef.componentInstance.message = 'Please confirm deleting';
        dialogRef.componentInstance.rightBtnText = 'Delete';
        dialogRef.afterClosed().subscribe(value => {
            if (!value) {
                return;
            }

            this.saleOrderSvc.deleteMultipleOrder({ companyId: this.customerName?.value }).subscribe(() => {
                this.getList();
                this.listOfSelectedItems = [];
                this.notify.showSuccessMessage('Deleted successfully');
            }, err => {
                this.notify.showSuccessMessage('Something went wrong');
                console.log('Error => ', err);
            });
        });
    }

    getListCompanies(q: string = this.searchCustomerName.value): void {
        q = this.customerName.value ? this.searchCustomerName.value : q;
        this.regSvc.getEcommerceCompanyList(q)
            .subscribe((data) => {
                if (!data || !data.items) {
                    return;
                }
                this.companyList = data.items;
            });
    }

    clearSelection() {
        this.customerName.reset();
        this.getListCompanies(this.searchCustomerName.value);
        this.listOfSelectedItems =[];
        this.listOfSelectedItemsBody = [];
    }

    downloadDoc(element): void {
        this.saleOrderSvc.downloadFile(element?.id, element?.orderDocuments[0]?.id);
    }

    uploadDoc(el: { saleOrderId: number, id: number, e: any, file: any }): void {
        const files = el.e.dataTransfer ? el.e.dataTransfer.files : el.e.target.files;

        this.saleOrderSvc.fileLoadedObserver.subscribe(() => {
            //this.getList();
            this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin ? this.getList(1, 100, '') : this.getList(1, 100, '', this.userSvc.company.id);
        })

        this.saleOrderSvc.uploadFile(files, el.saleOrderId, el.id);
    }

    updateDocs(id, body, element): void {
        this.saleOrderSvc.updateOrderDoc(element?.id, id, body).subscribe(data => {
            this.notify.showSuccessMessage('Document Uploaded');
        });
    }

    exportToExcel(): void {
        this.saleOrderSvc.downloadSaleOrders(
            this.pageParams?.pageIndex + 1,
            this.pageParams?.pageSize,
            this.searchStr.value,
            this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin ? this.customerName.value : this.userSvc.company.id,
            this.prepareSearchParams,
            this.currentSort?.active,
            this.currentSort?.direction,
            false,
            SaleOrderType.IsB2B.toString(),
            'B2B_SALES_ORDER_VISIBLITY_FIELD_RULE',
            PlaceStatus.Confirmed,
            false,
            {
                amountType: this.amountType.value,
                ShopId: this.shopIdByfilter.value,
                customerCountry: this.customerCountry.value,
            },
            true,
        ).subscribe(() => {

        });
    }

    openHideShowFieldsPopup(): void {
        const dialogRef = this.dialog.open(HideShowFieldsComponent, {
            width: '500px',
            data: { fields: this.fieldList, settingName: 'B2B_SALES_ORDER_VISIBLITY_FIELD_RULE' }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (!result) {
                return;
            }
            this.userSvc.hiddenFieldMPEvent.next("updates");
            this.fieldList = result;
            this.dataSource.data = result;
            this.getList();
        });
    }

    findDuplicate(data) {
        const marketplaceOrderId = data.map(item => (item?.marketplace?.marketplaceOrderId?.length > 6 ?
            item?.marketplace?.marketplaceOrderId?.slice(-5) : item?.marketplace?.marketplaceOrderId));
        return marketplaceOrderId.filter((item, index) => marketplaceOrderId.indexOf(item) !== index);
    }

    addNewSO(data) {
        this.consolidateShipmentService.getShipmentById(data).subscribe((res) => {
            if (res) {
                this.addNewSaleOrder = true;
                this.consolidateShipments(res);
            }
        });
    }

    consolidateShipments(data = null): void {
        const saleOrders = this.saleOrdersList.filter((so) => this.listOfSelectedItems.includes(so.id));

        // 1. Check for mixed Finalized/Active statuses
        const hasFinalized = saleOrders.some(el => 
            deliveredStatuses.includes(el.status) || el.status === SaleOrderStatus.CANCELED
        );
        const hasActive = saleOrders.some(el => 
            !deliveredStatuses.includes(el.status) && el.status !== SaleOrderStatus.CANCELED
        );

        if (hasFinalized && hasActive) {
            this.notify.showError('Consolidate shipment could not combine Delivered or Canceled SO with other');
            return;
        }

        // 2. Check if already included in another Consolidation
        if (saleOrders.some(el => el.consolNumber != null)) {
            this.notify.showError('Selected items contain sale order which included to another Consol Shipment');
            return;
        }

        // 3. Strict block: Any Delivered status prevents consolidation
        if (saleOrders.some(el => deliveredStatuses.includes(el.status))) {
            this.notify.showError("Delivered sale orders cannot be consolidated");
            return;
        }

        // 4. Region-based validation (UK vs EU)
        const hasEUCountry = saleOrders.some(el => el.marketplace.buyer.shippingAddress.country.name !== 'United Kingdom');
        const hasUKCountry = saleOrders.some(el => el.marketplace.buyer.shippingAddress.country.name === 'United Kingdom');

        if (hasEUCountry && hasUKCountry) {
            this.notify.showError('Shipments with destination country UK can not be consolidated to shipments with country from EU');
            return;
        }

        // 5. Dialog Configuration
        const dialogRef = this.dialog.open(ConsolidateShipmentsDetailsComponent, { width: '90vw', height: '80vh' });
        dialogRef.componentInstance.createMode = true;
        dialogRef.componentInstance.isEditable = !!data?.id;
        dialogRef.componentInstance.shipmentOrderType = OrderType.B2BImport;
        dialogRef.componentInstance.existingConsolId = data?.id;
        dialogRef.componentInstance.info = data;

        // Determine Subtype based on delivery/cancelation status
        if (hasFinalized) {
            dialogRef.componentInstance.subtype = ShipmentSubType.Return;
        } else {
            dialogRef.componentInstance.subtype = ShipmentSubType.Regular;
        }

        dialogRef.componentInstance.saleOrders = _.cloneDeep(saleOrders);
    }

    openUploadDialog(): void {
        this.dialog.open(XlsxUploadPopupPopupComponent);
    }

    applyChanges(): void {
        if (!this.listOfSelectedItems.length) {
            this.notify.showError('Please select at least one SO');
            return;
        }

        let dialogRef = this.dialog.open(OriginCountryPopupDialog);

        dialogRef.componentInstance.countries = this.fullCountriesList;
        dialogRef.componentInstance.orderIds = this.listOfSelectedItems.map(el => Number(el));

        dialogRef.afterClosed().subscribe(value => {
            this.listOfSelectedItems = [];
            this.getList();
        })
    }

      selectAllData(): void {
        console.log('select All from markeplace orders');
        this.getList(
            1,
            9999999,
            this.searchStr.value,
            this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin
                ? this.customerName.value
                : this.userSvc.company.id,
            true
        );
    }

    reloadAmountOfNewSO(): void {
        // Not the best solution, but we don't have the websocket which could automatically update data
        if (this.isAdmin || this.userSvc.isOfflineCustomer) {
            this.saleOrderSvc.countNewSO().subscribe(res => {
                this.userSvc.newMarketplaceSOCount = res;
            });
        }
    }

    uploadExcel(e): void {
        if (!e.target.files) {
            return;
        }
        const files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
        if (!this.uploadFileSvc.excelFileFormats[0].split(', ').find(el => el === files[0].type)) {
            this.fileInput.nativeElement.value = '';
            this.notify.showError('Should contain only XLSX files');
            return;
        }
        //this.uploadFileSvc.uploadSeveralFile(files, `xlsx-sale-order-files/${this.selectedShop}`);
        this.uploadFileSvc.uploadSeveralFile(files, `xlsx-sale-order-files/upload/file`);
        this.sub$.add(
            this.uploadFileSvc.allFilesLoaded().subscribe(data => {
                if (!data) {
                    return;
                }
                let file = data[0];
                if (!file) {
                    return;
                }
                file = JSON.parse(file.data);
                this.notify.showSuccessMessage('Uploaded successfully');
                this.fileInput.nativeElement.value = '';
                this.uploadFileSvc.filesLoadedObserver.next(null);
                //this.dialog.close();
            })
        );
    }
}
